import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const [activeIndex, setActiveIndex] = useState(0);
  const featured = articles.slice(0, 4);
  const current = featured[activeIndex];

  const goNext = () => setActiveIndex((prev) => (prev + 1) % featured.length);
  const goPrev = () => setActiveIndex((prev) => (prev - 1 + featured.length) % featured.length);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-14">
          <div className="lg:w-2/5">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[3/4]">
              <img
                src={current.coverImage}
                alt={current.title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-label font-semibold backdrop-blur-sm">
                {current.category}
              </span>
            </div>
          </div>

          <div className="lg:w-3/5 flex flex-col justify-center">
            <span className="text-xs text-foreground-500 font-label tracking-wider uppercase">
              （ 精选爆料 ）
            </span>
            <Link to={`/article/${current.slug}`} className="mt-3 block group cursor-pointer">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">
                {current.title.split('，').map((part, i, arr) => (
                  <span key={i} className={i === arr.length - 1 && part.length < 10 ? 'text-foreground-300' : ''}>
                    {part}{i < arr.length - 1 ? '，' : ''}
                  </span>
                ))}
              </h2>
            </Link>
            <blockquote className="mt-6 text-foreground-600 text-base leading-relaxed border-l-2 border-primary-300 pl-4">
              {current.excerpt}
            </blockquote>
            <div className="mt-6 flex items-center gap-3">
              <span className="text-sm text-foreground-500">—</span>
              <span className="font-heading font-bold text-foreground-800">{current.author}</span>
              <span className="text-foreground-400 text-xs">{current.publishDate}</span>
            </div>

            <div className="mt-8 flex items-center gap-3">
              <button
                onClick={goPrev}
                className="w-9 h-9 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:border-foreground-500 transition-colors cursor-pointer"
                aria-label="上一篇"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                onClick={goNext}
                className="w-9 h-9 rounded-full bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                aria-label="下一篇"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
              <div className="flex items-center gap-1.5 ml-3">
                {featured.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveIndex(i)}
                    className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                      i === activeIndex ? 'bg-primary-500 w-5' : 'bg-foreground-300'
                    }`}
                    aria-label={`文章 ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}